import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, CircularProgress } from "@mui/material";
import { QuestionSuccessIcon } from "@/icons/question-success-icon";
import VaModal from "../ui/va-modal/va-modal";
import { VaTitle, VaContent, ButtonWrapper, LogoWrapper, LogoCss, VaButtonNo } from "./email-verification-modal-style";
const EmailVerificationModal = (props) => {
    // variables & states
    const { visible, onClose, setVisible, onConfirm = () => { }, title, content, loading } = props;
    // functions
    return (_jsxs(VaModal, { hideCloseIcon: false, visible: visible, setVisible: setVisible, maxWidth: 420, headerSpacing: "0px", children: [_jsx(LogoWrapper, { children: _jsx(LogoCss, { children: _jsx(QuestionSuccessIcon, {}) }) }), _jsxs(VaTitle, { children: [" ", title] }), _jsx(VaContent, { children: content }), _jsxs(ButtonWrapper, { children: [_jsx(VaButtonNo, { children: _jsx(Button, { id: "on-button", onClick: onClose, variant: "outlined" // or "contained" / "text" depending on your design
                            , sx: {
                                borderRadius: "50px", // round shape
                                width: "140px",
                                color: "text.primary", // or your theme's tertiary equivalent
                                borderColor: "text.primary",
                            }, children: "No" }) }), _jsx(Button, { id: "yes-button", onClick: onConfirm, variant: "contained", color: "primary", disabled: loading, sx: {
                            borderRadius: "50px", // makes it round/pill-shaped
                            width: "140px",
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: 'rgb(50, 78, 207)',
                            alignItems: "center",
                            gap: 1, // spacing between spinner and text if needed
                        }, children: loading ? _jsx(CircularProgress, { size: 20, color: "inherit" }) : "Yes" })] })] }));
};
export default EmailVerificationModal;
